// frontend/src/pages/dashboard/Profile.js
import React, { useState, useEffect } from 'react';

function Profile() {
  const [name, setName]         = useState('');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');

  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage]           = useState('');
  const [error, setError]               = useState('');

  // Fetch user profile on mount, using session-based auth
  useEffect(() => {
    fetch('/api/auth/profile', {
      method: 'GET',
      credentials: 'include', // important for session-based requests
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch profile');
        }
        return res.json();
      })
      .then((data) => {
        setName(data.name || '');
        setEmail(data.email || '');
      })
      .catch((err) => {
        console.error(err);
        setError('Could not load profile. You may not be logged in.');
      });
  }, []);

  // Handle form submission to update profile
  const handleProfileUpdate = (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    const body = { name, email };
    // If user entered a new password, include it
    if (password.length > 0) {
      body.password = password;
    }

    fetch('/api/auth/profile', {
      method: 'PUT',
      credentials: 'include', // send session cookie
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Update failed');
        }
        return res.json();
      })
      .then((data) => {
        setMessage(data.message || 'Profile updated');
      })
      .catch((err) => {
        console.error(err);
        setError('Failed to update profile. You may not be logged in.');
      });
  };

  // Show/hide password
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  // Show an error alert if there's an error
  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      </div>
    );
  }

  // Main UI
  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h2 className="card-title mb-3">Your Profile</h2>

          {message && (
            <div className="alert alert-success" role="alert">
              {message}
            </div>
          )}

          <form onSubmit={handleProfileUpdate}>
            {/* Name */}
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Name</label>
              <input
                id="name"
                className="form-control"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            {/* Email */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email Address</label>
              <input
                id="email"
                className="form-control"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {/* Password (Optional) */}
            <div className="mb-3">
              <label htmlFor="password" className="form-label">New Password (Optional)</label>
              <div className="input-group">
                <input
                  id="password"
                  className="form-control"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
              <div className="form-text">
                Leave blank if you don’t want to change your password.
              </div>
            </div>

            <button className="btn btn-primary" type="submit">
              Save Changes
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Profile;
